module.exports = __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/calendar.bf52c3c5.svg";